// Author Liang Gang Qiang
// Date 2023-03-10 10:05:35

class SithMesPrdProjectProfitCenter {
constructor({
        id = null,
        projectCode = '',
        wbsNumber = '',
        profitCenter = '',
        costOverheadGroup = '',
        remark = ''}
= {}) {
    this.id = id;
    this.projectCode = projectCode;
    this.wbsNumber = wbsNumber;
    this.profitCenter = profitCenter;
    this.costOverheadGroup = costOverheadGroup;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdProjectProfitCenter();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdProjectProfitCenter.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdProjectProfitCenter.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'wbsNumber',
        label: 'label.sith.prd.sithMesPrdProjectProfitCenter.grid.wbsNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'profitCenter',
        label: 'label.sith.prd.sithMesPrdProjectProfitCenter.grid.profitCenter',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'costOverheadGroup',
        label: 'label.sith.prd.sithMesPrdProjectProfitCenter.grid.costOverheadGroup',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdProjectProfitCenter.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    projectCodeFilter : '',
    wbsNumberFilter : '',
    profitCenterFilter : '',
    costOverheadGroupFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'projectCodeFilter',
        label: 'label.sith.prd.sithMesPrdProjectProfitCenter.filter.projectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'wbsNumberFilter',
        label: 'label.sith.prd.sithMesPrdProjectProfitCenter.filter.wbsNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'profitCenterFilter',
        label: 'label.sith.prd.sithMesPrdProjectProfitCenter.filter.profitCenter',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'costOverheadGroupFilter',
        label: 'label.sith.prd.sithMesPrdProjectProfitCenter.filter.costOverheadGroup',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdProjectProfitCenter.entity.projectCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'wbsNumber',
        label: 'label.sith.prd.sithMesPrdProjectProfitCenter.entity.wbsNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'profitCenter',
        label: 'label.sith.prd.sithMesPrdProjectProfitCenter.entity.profitCenter',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'costOverheadGroup',
        label: 'label.sith.prd.sithMesPrdProjectProfitCenter.entity.costOverheadGroup',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdProjectProfitCenter.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesPrdProjectProfitCenter, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
